import type { LimuloMe } from '../../types/limulo.ts';

/**
 * Il nome pubblico nel backgammon e' SOLO il nickname QLASH (I-898; Luca, L-3575 (b), I-1042).
 * QGammon#149 lo legge al login dall'intestazione qui sotto; senza, la persona e' «Player <hash>».
 * Contratto di qgammon-orc (21/10 23:00:50Z):
 *   1. su ogni chiamata REST a QGammon fatta col Bearer della persona;
 *   2. il valore e' il `nickname` di `GET /v1/me` di Limulo, e nient'altro: mai lo username o il nome
 *      di Logto, mai il nome Telegram (L-2636), mai il `name` di Limulo;
 *   3. forma `^[a-z0-9_]{3,32}$` dopo il trim, SENZA minuscolizzare;
 *   4. fuori forma vale come assente: nessun 400 lato server, quindi qui nessuna intestazione e il
 *      valore non finisce in nessun log.
 *
 * Questo file e' puro (nessun `import.meta.env`, nessuno store) apposta, per essere esercitato sotto Node.
 *
 * 🔴 LA TRAPPOLA: `auth.user.username` NON e' il nickname. `lib/limulo/identity.ts` ci mette il
 * nickname, ma se `requiresNickname` manca ripiega sul `name` di Limulo, che in prod arriva dal
 * monolite (e senza una scelta e' il segnaposto «Player»). Un valore che passa la forma puo' quindi
 * NON essere il nickname. ⇒ qui si legge `nickname` da `/v1/me`, e solo con `requiresNickname === false`
 * (esplicito: `true`, `null` e assente non bastano). Il campo dello store e' `AuthUser.nicknameQlash`,
 * scritto SOLO da `nicknameQlashDaMe` e da `setNickname`; nessuno legge `username` per questo scopo.
 */
export const QGAMMON_DISPLAY_NAME_HEADER = 'X-QGammon-Display-Name';

const FORMA_NICKNAME = /^[a-z0-9_]{3,32}$/;

/** Il valore se e' un nickname in forma (dopo il trim), altrimenti `undefined`. Non cambia le maiuscole. */
export function nicknameInForma(valore: unknown): string | undefined {
  if (typeof valore !== 'string') return undefined;
  const pulito = valore.trim();
  return FORMA_NICKNAME.test(pulito) ? pulito : undefined;
}

/**
 * Il nickname QLASH di una risposta `GET /v1/me`: `nickname`, e solo se la scelta e' fatta
 * (`requiresNickname === false`). Ogni altro caso — `true`, `null`, assente, nickname fuori forma — e' `undefined`.
 */
export function nicknameQlashDaMe(me: LimuloMe | null | undefined): string | undefined {
  const user = me?.user;
  if (!user || user.requiresNickname !== false) return undefined;
  return nicknameInForma(user.nickname);
}

// Lo tiene in memoria `useNicknameQgammon` (hooks/), dallo store; `qgammonAuthHeaders` non e' un
// componente e non puo' leggerlo da solo. Mai persistito.
let corrente: string | undefined;

export function impostaNicknameQgammon(valore: unknown): void {
  corrente = nicknameInForma(valore);
}

/** L'intestazione da aggiungere a una chiamata col Bearer: vuota se il nickname manca o e' fuori forma. */
export function intestazioneNomeQgammon(): Record<string, string> {
  return corrente ? { [QGAMMON_DISPLAY_NAME_HEADER]: corrente } : {};
}
